import data from "../data/data";
import FolderWindow from "./FolderWindow/FolderWindow";
import Folders from "./Folder/Folders";

const Desktop = ({ openFolderName, setOpenFolderName, clicked, setClicked }) => {
  const folderData = data.find((f) => f.name === openFolderName);

  return (
    <>
      {openFolderName && folderData && (
        <FolderWindow
          key={openFolderName}
          name={openFolderName}
          content={folderData.content}
          onClose={() => setOpenFolderName(null)}
        />
      )}
      <Folders
        setOpenFolderName={setOpenFolderName}
        clicked={clicked}
        setClicked={setClicked}
      />
    </>
  );
};

export default Desktop;
